import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

import { DurationIndicator, StoryStatus } from './DurationIndicator/index.tsx';

const Root = styled(Horizontal).attrs({ gap: 0.5 })`
  width: 100%;
  padding: var(--unit) var(--double-unit) 0;
  height: calc(5 * var(--unit));
  & > * {
    flex: 1;
  }
`;

type Props = {
  steps: number[];
  playing: boolean;
  currentlyPlayingStoryIndex: number;
  onStoryEnd: () => void;
  pause?: boolean;
};
export const DurationsIndicator = ({
  steps,
  playing,
  currentlyPlayingStoryIndex,
  onStoryEnd,
  pause,
}: Props) => {
  return (
    <Root>
      {steps.map((duration, i) => {
        let storyStatus;
        if (currentlyPlayingStoryIndex > i) {
          storyStatus = StoryStatus.SEEN;
        } else if (currentlyPlayingStoryIndex < i) {
          storyStatus = StoryStatus.NOT_SEEN;
        }

        return (
          <DurationIndicator
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            playing={!!playing && i === currentlyPlayingStoryIndex}
            storyStatus={storyStatus}
            duration={duration}
            onFinish={onStoryEnd}
            pause={pause}
          />
        );
      })}
    </Root>
  );
};
